var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4497_11949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 29.6484C23.0901 29.6484 29.6484 23.0901 29.6484 15C29.6484 6.90989 23.0901 0.351562 15 0.351562C6.90989 0.351562 0.351562 6.90989 0.351562 15C0.351562 23.0901 6.90989 29.6484 15 29.6484Z",
    fill: "url(#paint0_linear_4497_11949)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1107 6.86182H11.8932C9.11979 6.86182 6.86719 9.11442 6.86719 11.8879V18.1053C6.86719 20.8787 9.11979 23.1313 11.8932 23.1313H18.1107C20.8841 23.1313 23.1367 20.8787 23.1367 18.1053V11.8879C23.1367 9.11442 20.8841 6.86182 18.1107 6.86182ZM21.3203 18.1118C21.3203 19.8827 19.8815 21.328 18.1042 21.328H11.8867C10.1159 21.328 8.67057 19.8892 8.67057 18.1118V11.8944C8.67057 10.1235 10.1094 8.67822 11.8867 8.67822H18.1042C19.875 8.67822 21.3203 10.117 21.3203 11.8944V18.1118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10.8396C12.7083 10.8396 10.8398 12.7081 10.8398 14.9998C10.8398 17.2914 12.7083 19.1599 15 19.1599C17.2917 19.1599 19.1602 17.2914 19.1602 14.9998C19.1602 12.7081 17.2917 10.8396 15 10.8396ZM15 17.5258C13.6068 17.5258 12.474 16.393 12.474 14.9998C12.474 13.6065 13.6068 12.4737 15 12.4737C16.3932 12.4737 17.526 13.6065 17.526 14.9998C17.526 16.393 16.3932 17.5258 15 17.5258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4737 11.2959C19.857 11.2337 20.1173 10.8726 20.0552 10.4894C19.993 10.1061 19.632 9.84575 19.2487 9.90789C18.8654 9.97002 18.6051 10.3311 18.6672 10.7144C18.7293 11.0976 19.0904 11.358 19.4737 11.2959Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4497_11949",
    x1: 3.84629,
    y1: 26.1537,
    x2: 24.6633,
    y2: 5.33665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518459,
    stopColor: "#FEDB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#FEC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#FE983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#FE5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000DC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4497_11949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.04c72159c0b91cf50bf66ca5a06bdf7f.svg";
export { ForwardRef as ReactComponent };